import { render } from "./OpinionsGallery.vue?vue&type=template&id=445e6914&scoped=true"
import script from "./OpinionsGallery.vue?vue&type=script&lang=js"
export * from "./OpinionsGallery.vue?vue&type=script&lang=js"

import "./OpinionsGallery.vue?vue&type=style&index=0&id=445e6914&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445e6914"]])

export default __exports__